import { render, staticRenderFns } from "./table-logistic-one.vue?vue&type=template&id=1fc19e7b&scoped=true&"
import script from "./table-logistic-one.vue?vue&type=script&lang=js&"
export * from "./table-logistic-one.vue?vue&type=script&lang=js&"
import style0 from "./table-logistic-one.vue?vue&type=style&index=0&id=1fc19e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc19e7b",
  null
  
)

export default component.exports